// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import moment from 'moment'

// instead of creating custom formatters for these cells,
// just create properties for the values of interest.
// TODO - Once true antenna data is in place, refactor the below for values which cannot be null
const prepData = arr => arr.map(d => {
  const {
    compliance,
    diameter,
    diameterUS,
    hiFrequency,
    loFrequency,
    modelNumber,
    polarization,
    rpeDate,
    rpeNumber,
  } = d

  d.compliance = compliance || 'n/a'
  d.diameterMandFt = diameter ? `${diameter} / ${diameterUS.toFixed(2)}` : 'n/a'
  d.frequencyRange = hiFrequency ? `${loFrequency} - ${hiFrequency}` : 'n/a'
  d.modelNumberAndFeedDir = modelNumber.trim()
  d.patternDate = rpeDate === null ? 'n/a' : moment(rpeDate).format('YYYY/MM/DD')
  d.pol = polarization ? polarization[0] : ''
  d.rpeNumber = rpeNumber || 'n/a'
  d.uniqueId = 'antennaCode' // so that DataTable can create a unique id

  return d
})

export default prepData
